import useScrollReveal from "../hooks/useScrollReveal";

/**
 * KineticText — splits text into characters that animate in sequence on scroll.
 * <KineticText text="Hello world" /> renders <span className="kinetic">…</span>
 * Each character has incremental animation-delay.
 */
export default function KineticText({ text, className = "", as: Tag = "span", staggerMs = 30 }) {
  const ref = useScrollReveal(0.4);
  const chars = Array.from(text || "");
  return (
    <Tag ref={ref} className={`kinetic ${className}`} aria-label={text}>
      {chars.map((c, i) => (
        <span key={i} aria-hidden="true" style={{ animationDelay: `${i * staggerMs}ms` }}>
          {c === " " ? "\u00A0" : c}
        </span>
      ))}
    </Tag>
  );
}
